import * as forge from 'node-forge';

export abstract class EncryptionService {

    generatePrivateKey(): any {
        // Generate an RSA key pair
        const keypair = forge.pki.rsa.generateKeyPair(2048);
        // Export the keys as PEM strings
        return forge.pki.privateKeyToPem(keypair.privateKey);
    }

    generatePublicKey(): any {
        // Generate an RSA key pair
        const keypair = forge.pki.rsa.generateKeyPair(2048);
        // Export the keys as PEM strings
        return forge.pki.publicKeyToPem(keypair.publicKey);
    }

  static encryptData(publicKey:string,data: string): string {
    const publicKeyObj = forge.pki.publicKeyFromPem(publicKey);
    const encryptedData = publicKeyObj.encrypt(data,  'RSAES-PKCS1-V1_5');
    return forge.util.encode64(encryptedData);
  }
}